import { createClient } from '@supabase/supabase-js';

// Read Supabase config from environment. For Create React App, prefix with REACT_APP_
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://dummy.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'dummy-anon-key';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
	// Warn during development if env vars are missing
	// Set values in a local .env or in your hosting provider's environment variables
	// See .env.example in the repo for variable names
	// eslint-disable-next-line no-console
	console.warn('Missing Supabase environment variables: REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
	auth: {
		persistSession: false,
		autoRefreshToken: false,
		detectSessionInUrl: false,
	},
});

export default supabase;
